import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { motion } from 'framer-motion';
import { useDarkMode } from '../contexts/DarkModeContext';
import { useTranslation } from 'react-i18next';
import './DarkModeToggle.css';
const DarkModeToggle = () => {
    const { isDarkMode, toggleDarkMode } = useDarkMode();
    const { t } = useTranslation();
    return (_jsxs(motion.button, { className: `dark-mode-toggle ${isDarkMode ? 'dark' : 'light'}`, onClick: toggleDarkMode, whileHover: { scale: 1.05 }, whileTap: { scale: 0.95 }, title: isDarkMode ? t('darkMode.disable', 'Disable Dark Mode') : t('darkMode.enable', 'Enable Dark Mode'), children: [_jsx(motion.div, { className: "toggle-icon", animate: { rotate: isDarkMode ? 180 : 0 }, transition: { duration: 0.3 }, children: isDarkMode ? '🌙' : '☀️' }), _jsx("span", { className: "toggle-text", children: isDarkMode ? t('darkMode.dark', 'Dark') : t('darkMode.light', 'Light') })] }));
};
export default DarkModeToggle;
